export class LoginModel {
  userName!: string;
  password!: string;
}

export class User {
  id!: string
  first_name!: {
    ar: string
    en: string
  }
  last_name!: {
    ar: string
    en: string
  }
  email!: string
  phone_number!: string
  image!: string
  created_at!: string
  roles!: Role[]
  type!: string
  complete_personality_test!: boolean
  is_test_skip!: boolean
  is_account_verify!: boolean
  is_personal_information_completed!: boolean
}

export interface Role {
  name: string
  id: string
  role_code: string
}

